/* TODO:
1. Replace urls for modify
*/
import React, { useState, useEffect } from 'react';
import DimpleDivider from '@tds/core-dimple-divider';
import InputGroup from '@tds/community-input-group';
import WlnFilters from '../../components/filters/wlnfilters';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { apiHost, config as axiosConfig } from '../utils/request';
import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';
import { ContentWrapper, Box } from '../design/css';
import { Search } from './css';
import EN from '../../EN.json';
import FR from '../../FR.json';
import Table from '../design/shared/table';
import request from '../utils/request';
import { OrderListModel, OrderHeaderModel } from './models';

import ValidateLoader from '../UI/validateLoader';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import {
  CONSTANT,
  quoteToolForm,
  orderDetailsForm,
  wirelineAndSecureBusinessForm
} from '../utils/constant';
import { getButton, getLink, getStatus, getStatusFiltersPayload } from './utils';
import MessageNotification from '../messageNotification';
import stringInterpolation from '../utils/stringInterpolation';
import { useLocaleContext } from '../context/LocaleContext';
import { getOptions, ChannelModel } from '../orders/models';
import { getFormattedDate } from '../utils/utils';
const connectionKey = 'srtDashboard';
const ordersConnectionKey = 'ORDERS';

const initialFilterState = {
  startDate: null,
  endDate: null,
  validationStartDate: null,
  validationEndDate: null,
  filterCriteria: null,
  channelId: [],
  province: [],
  assignee: [],
  dealership: [],
  storeCode: [],
  channelOrgCodes: [],
  submitter: [],
  valueChain: [],
  activationLanguage: [],
  createdBy: [],
  productId: [],
  status: [],
  channelOrgCode: []
};

const SrtDashboard = ({ location: { search } }) => {
  let url = '';
  const local = useLocaleContext();
  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        WLSLandingPage: { searchLabel, searchHint }
      }
    }
  } = local === 'en-US' ? EN : FR;
  const {
    KEYS: { CHANNELS }
  } = CONSTANT;

  const localizedStrings = useLocalizedStringsContext();
  const staticLabels = localizedStrings[connectionKey];
  const {
    confirmationDialog,
    noOrders,
    loadingMessage,
    confirm,
    cancel,
    proceedWithOrder,
    locked,
    saveQuote,
    continueLabel,
    deleteOrderLabel,
    continueAction,
    modify,
    deleteAction,
    confirmationMessage,
    manage,
    successActionMessage,
    status,
    createOrderLabel
  } = staticLabels;
  const staticLabelsForFilters = localizedStrings[ordersConnectionKey];
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { provinces, channel } = userProfile;
  const { name: userChannelName } = channel || {};

  const products = staticLabelsForFilters.productsOptions.sort();
  const statuses = staticLabelsForFilters.statusOptions.sort();
  const valueChains = [
    'TSB',
    'ADT Bus',
    'Complex Lead',
    'WLN',
    'ADT Cons',
    'TH Opt Out'
  ];
  const activationLanguages = ['English', 'French'];
  const history = useHistory();
  const { q } = queryString.parse(history.location.search);
  const [searchString, setSearchString] = useState(q);
  const [filterState, setFilterState] = useState(initialFilterState);
  const [filters, setFilters] = useState('');
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [data, setData] = useState();
  const [action, setAction] = useState();
  const [salesRepNames, setSalesRepNames] = useState(null);
  const [channels, setChannels] = useState(null);
  const [assignees, setAssignees] = useState(null);
  const [dealerships, setDealerShips] = useState(null);
  const [storeCodes, setStoreCodes] = useState(null);
  const [channelOrgCodes, setChannelOrgCodes] = useState(null);
  const [submitters, setSubmitters] = useState(null);
  const SrtPage = localStorage.getItem('SrtPage')
    ? localStorage.getItem('SrtPage')
    : 1;
  const [srtPage, setSrtPage] = useState(SrtPage);
  const [tableHeaders, setTableHeaders] = useState(
    new OrderHeaderModel(localizedStrings[ordersConnectionKey])
  );

  const { page } = queryString.parse(search);
  const pageSize = 50;
  const filterData = {
    salesRepNames,
    assignees,
    dealerships,
    storeCodes,
    channelOrgCodes,
    submitters,
    channels,
    provinces,
    products,
    statuses,
    valueChains,
    activationLanguages
  };
  const isSbsTelesalesTiChannel = userChannelName === CHANNELS.SBS_TELESALES_TI;
  const isChannelSMBDigitalFr =
    userChannelName === CHANNELS['SMB TI Digital - FR'];
  useEffect(() => {
    setTableHeaders(
      new OrderHeaderModel(localizedStrings[ordersConnectionKey])
    );
  }, [localizedStrings]);

  const updateFilters = (key, value) => {
    setFilterState({ ...filterState, [key]: value });
  };

  const getFilterPayload = () => {
    const payload = {
      ...filterState,
      assignedUserId: filterState.assignee.length && filterState.assignee[0].id,
      submittedBy:
        filterState.submitter.length && filterState.submitter[0].value,
      province: filterState.province.map(row => row.value),
      channelId: filterState.channelId.map(row => row.value)
    };
    delete payload.assignees;

    if (filterState.startDate)
      payload.startDate = getFormattedDate(filterState.startDate);
    if (filterState.endDate)
      payload.endDate = getFormattedDate(filterState.endDate);
    if (filterState.validationStartDate)
      payload.validationStartDate = getFormattedDate(
        filterState.validationStartDate
      );
    if (filterState.validationEndDate)
      payload.validationEndDate = getFormattedDate(
        filterState.validationEndDate
      );
    return payload;
  };
  const getFilterParams = payload => {
    let allFilterParamsArray = {};
    payload.province && payload.province.length
      ? (allFilterParamsArray.province = payload.province.map((n, index) => n))
      : undefined;

    payload.channelId && payload.channelId.length
      ? (allFilterParamsArray.channelId = payload.channelId.map(
          (n, index) => n
        ))
      : undefined;
    payload.assignee && payload.assignee.length
      ? (allFilterParamsArray.assignee = payload.assignee.map(
          (n, index) => n.value
        ))
      : undefined;
    payload.productId && payload.productId.length
      ? (allFilterParamsArray.product = payload.productId.flatMap(
          (n, index) => n.value
        ))
      : undefined;
    if (payload.status && payload.status.length) {
      const { status, quoteStatus } = getStatusFiltersPayload(payload.status);
      if (status.length) allFilterParamsArray.status = status;
      if (quoteStatus.length) allFilterParamsArray.quoteStatus = quoteStatus;
    }
    payload.valueChain && payload.valueChain.length
      ? (allFilterParamsArray.valueChain = payload.valueChain.map(
          (n, index) => n.value
        ))
      : undefined;
    payload.dealership && payload.dealership.length
      ? (allFilterParamsArray.dealership = payload.dealership.map(
          (n, index) => n.value
        ))
      : undefined;
    payload.storeCode && payload.storeCode.length
      ? (allFilterParamsArray.storeCode = payload.storeCode.map(
          (n, index) => n.value
        ))
      : undefined;
    payload.channelOrgCode && payload.channelOrgCode.length
      ? (allFilterParamsArray.channelOrgCode = payload.channelOrgCode.map(
          (n, index) => n.value
        ))
      : undefined;

    payload.activationLanguage && payload.activationLanguage.length
      ? (allFilterParamsArray.activationLanguage =
          payload.activationLanguage[0].value)
      : undefined;
    payload.startDate
      ? (allFilterParamsArray.startDate = payload.startDate)
      : undefined;
    payload.endDate
      ? (allFilterParamsArray.endDate = payload.endDate)
      : undefined;
    payload.validationStartDate
      ? (allFilterParamsArray.validationStartDate = payload.validationStartDate)
      : undefined;
    payload.validationEndDate
      ? (allFilterParamsArray.validationEndDate = payload.validationEndDate)
      : undefined;
    if (payload.startDate || payload.endDate) {
      allFilterParamsArray.filterCriteria = 'createdAt';
    }
    payload.submitter && payload.submitter.length
      ? (allFilterParamsArray.submitter = payload.submitter.map(
          (n, index) => n.value
        ))
      : undefined;

    return allFilterParamsArray;
  };

  const filterOrders = (isResetMode = false) => {
    if (isResetMode === true) {
      fetchData();
    } else {
      const payload = getFilterPayload();
      setLoading(true);
      const allFilterParamsArray = getFilterParams(payload);
      setFilters(allFilterParamsArray);
      axios
        .post(
          `${apiHost}/orders/filter?typeOfOrder=wln&pageNumber=${srtPage}&pageSize=${pageSize}&findAll=0`,
          { ...allFilterParamsArray, createdBy: userProfile.id },
          { ...axiosConfig() }
        )
        .then(response => {
          const {
            data: { totalCount: ordersCount, results: orders }
          } = response;
          setData({
            orders,
            count: ordersCount
          });
          setLoading(false);
        })
        .catch(() => {});
    }
  };
  const applyFilters = () => {
    setSrtPage(1);
    localStorage.setItem('srtPage', 1);
    filterOrders();
  };

  const resetFilters = () => {
    //localStorage.setItem('AllOrdersPageWLS', 1); // reset local stored page number to page = 1
    setSrtPage(1); // reset state of page number to page = 1
    localStorage.setItem('srtPage', 1);
    setFilterState({
      ...initialFilterState
    });
    setFilters('');
    filterOrders(true);
  };
  const fetchOrders = () => {
    return request.get(
      `/orders?typeOfOrder=wln&pageNumber=${srtPage ||
        1}&pageSize=${pageSize}&${url}&findAll=0`
    );
  };
  const fetchData = () => {
    setLoading(true);
    fetchOrders().then(ordersResp => {
      const {
        data: { totalCount: ordersCount, results: orders }
      } = ordersResp;
      setData({
        orders,
        count: ordersCount
      });
      setLoading(false);
    });
  };

  const fetchFiltersData = async () => {
    return axios
      .get(`${apiHost}/get-wln-filters?${url}`, axiosConfig())
      .then(response => {
        setSalesRepNames(_.get(response, 'data.salesReps', 0));
        setAssignees(_.get(response, 'data.usersList', 0));
        setSubmitters(_.get(response, 'data.usersList', 0));
        setChannels(
          getOptions(_.get(response, 'data.channels', 0), ChannelModel)
        );
        setDealerShips(_.get(response, 'data.dealerships', 0));
        setStoreCodes(_.get(response, 'data.storeCodes', 0));
        setChannelOrgCodes(_.get(response, 'data.channelOrgCodes', 0));
      })
      .catch(err => {});
  };
  const deleteOrder = () => {
    return request.delete(`/orders/${order.id}`).then(() => {
      setOrder({ ...order, open: false, isUpdated: true });
      fetchData();
    });
  };

  const getRedirectUrl = (row, formName) => {
    history.push({
      pathname: `/${row.locale}/${row.categoryName}/${formName}`,
      search: `?orderId=${row.id}&step=${row.step}&isEditing=true`
    });
    window.location.reload();
  };

  const getModifyUrl = row => {
    history.push({
      pathname: `/${row.locale}/${row.categoryName}/${wirelineAndSecureBusinessForm}`,
      search: `?orderId=${row.id}&step=2&isEditing=true`
    });
    setOrder({ ...order, open: false });
    window.location.reload();
  };

  const actionContinue = row => {
    setAction(continueAction);
    setOrder({ open: true, orderDetails: row });
  };

  const actionDelete = (id, orderId) => {
    setAction(deleteAction);
    setOrder({ open: true, id, orderId });
  };

  const actionProceed = row => {
    setAction(proceedWithOrder);
    setOrder({ open: true, orderDetails: row });
  };

  const onConfirm = () => {
    switch (action) {
      case proceedWithOrder:
        getRedirectUrl(order.orderDetails, orderDetailsForm);
        break;
      case continueAction:
        getRedirectUrl(order.orderDetails, quoteToolForm);
        break;
      case modify:
        getModifyUrl(order.orderDetails);
        break;
      case deleteAction:
        deleteOrder();
        break;
      default:
    }
  };
  const getActions = row => {
    const { status: orderStatus, quoteStatus } = row;
    const { statusText: finalStatus } = getStatus(orderStatus, quoteStatus);
    const incompleteStatus = finalStatus === status.incomplete;
    const approvedQuote = finalStatus === status.approved;
    const incompleteOrderStatus = finalStatus === status.orderIncomplete;
    const completed = finalStatus === status.validated;
    let actions;
    if (incompleteStatus) {
      actions = (
        <>
          {getButton(() => actionContinue(row), continueLabel)}
          {getButton(() => actionDelete(row.id, row.orderId), deleteOrderLabel)}
        </>
      );
    } else if (approvedQuote) {
      actions = (
        <>
          {getButton(() => actionProceed(row), createOrderLabel)}
          {getButton(() => actionDelete(row.id, row.orderId), deleteOrderLabel)}
          {!isChannelSMBDigitalFr && getLink(row.id, saveQuote)}
        </>
      );
    } else if (incompleteOrderStatus) {
      actions = (
        <>
          {getButton(() => actionProceed(row), proceedWithOrder)}
          {getButton(() => actionDelete(row.id, row.orderId), deleteOrderLabel)}
          {/* //save quote button will be hidden if channel SBS telesales ti */}
          {!isSbsTelesalesTiChannel &&
            !isChannelSMBDigitalFr &&
            getLink(row.id, saveQuote)}
        </>
      );
    } else if (completed) {
      actions = <>{getButton(() => actionProceed(row), locked, true)}</>;
    } else {
      actions = (
        <>
          {getButton(() => actionContinue(row), continueLabel)}
          {getButton(() => actionDelete(row.id, row.orderId), deleteOrderLabel)}
        </>
      );
    }
    return actions;
  };

  const onSearchClick = () => {
    setSrtPage(1);
    localStorage.setItem('srtPage', 1);
    history.push({
      search: `?q=${searchString}`
    });
  };

  const onClear = () => {
    setSearchString('');
    setSrtPage(1);
    localStorage.setItem('srtPage', 1);
    history.push({
      search: ''
    });
  };

  useEffect(() => {
    (async () => {
      await fetchFiltersData();
    })();
    if (searchString) {
      url = `q=${searchString}`;
      setSrtPage(1);
      localStorage.setItem('srtPage', 1);
    } else {
      url = filters; // findAll=0 (for MY Orders) & findAll=1 (for All Orders)
    }
  }, []);
  useEffect(() => {
    if (searchString) {
      url = `q=${searchString}`;
      setSrtPage(1);
      localStorage.setItem('srtPage', 1);
      fetchData();
    } else if (filters) {
      filterOrders(); // findAll=0 (for MY Orders) & findAll=1 (for All Orders)
    } else {
      fetchData();
    }
  }, [page, srtPage, searchString]);

  return (
    <>
      <DimpleDivider />
      <div style={{ padding: '0 6rem' }}>
        <WlnFilters
          updateFilters={(key, value) => updateFilters(key, value)}
          filterState={filterState}
          onApplyFilters={applyFilters}
          onResetFilters={resetFilters}
          data={filterData}
          staticLabels={staticLabelsForFilters}
          isOrerFullfilment={true}
        />
        <Search>
          <div></div>
          <InputGroup
            label={searchLabel}
            hint={searchHint}
            style={{ marginLeft: 20 }}
            defaultValue={searchString}
            onClearButtonClick={() => onClear()}
            onChange={e => setSearchString(e.target.value)}
            onButtonClick={() => onSearchClick()}
            onKeyDown={e => e.key === 'Enter' && onSearchClick()}
          />
        </Search>
      </div>
      <DimpleDivider />
      <ContentWrapper>
        {loading ? (
          <ValidateLoader message={loadingMessage} />
        ) : (
          <>
            {order && order.isUpdated && (
              <Box pt={20} pb={20}>
                <MessageNotification
                  variant="success"
                  message={stringInterpolation(
                    successActionMessage,
                    action,
                    order.orderId
                  )}
                />
              </Box>
            )}
            {data && data.orders && data.orders.length ? (
              <>
                <Table
                  title={manage}
                  header={tableHeaders}
                  data={data.orders}
                  actions={getActions}
                  dataModel={OrderListModel}
                  currentPage={parseInt(srtPage || 1, 10)}
                  setSrtPage={setSrtPage}
                  count={data.count}
                  actionsDisplay="grid"
                  step={pageSize}
                />
              </>
            ) : (
              <p style={{ textAlign: 'center' }}>{noOrders}</p>
            )}
          </>
        )}
        {
          <Modal
            heading={confirmationDialog}
            bodyText={`${confirmationMessage} ${action} ?`}
            confirmCTAText={confirm}
            cancelButtonType="button"
            cancelCTAText={cancel}
            onConfirm={() => onConfirm()}
            onClose={() => setOrder({ ...order, open: false })}
            isOpen={action && order.open}
          />
        }
      </ContentWrapper>
    </>
  );
};

SrtDashboard.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default SrtDashboard;
